export const iconFontAwesomeNumbers2 = (
	<i className="fa-solid fa-2"></i>
);
